module.exports = __webpack_public_path__ + "static/media/debug.rgb.6e2ed23f.frag";